function OnboardImage4Dark() {
  return (
    <svg style={{ width: '100%' }} viewBox='0 0 387 408' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M296.174 100.5H94.0991M94.0991 100.5H90.3361V106.521H83.1863V111.037H77.1654V117.057H71.5209V123.455H65.5V248.764H76.7891M94.0991 100.5V219.412M94.0991 219.412H180.273M94.0991 219.412V226.186H88.4545V232.206H82.81V237.851H76.7891V248.764M192.691 324.401V219.412H180.273M192.691 324.401H318M192.691 324.401V329.669H186.67V335.69H179.52V340.958H174.628V353M318 324.401V123.455M318 324.401V329.669H311.979V335.69H306.711V340.958H300.314V347.355H294.669V353M296.174 353H294.669M162.586 248.764V353H174.628M162.586 248.764V243.119H169.36V236.722H173.876V231.454H180.273V219.412M162.586 248.764H76.7891M294.669 353H174.628'
        stroke='black'
        strokeWidth='3.76304'
      />
      <rect x='297.68' y='102.758' width='6.02086' height='5.26826' fill='black' />
      <rect x='303.7' y='108.779' width='6.02086' height='5.26826' fill='black' />
      <rect x='308.969' y='114.047' width='6.02086' height='5.26826' fill='black' />
      <path
        d='M297.68 102.382C231.576 102.632 97.7869 102.382 95.9806 102.382V217.531H194.572V322.519L314.99 321.767L316.118 123.078L314.99 119.315H308.969V114.047H303.842V108.779L303.7 108.026H300.69H297.68V105.016V102.382Z'
        fill='#391998'
      />
      <rect x='112' y='147.599' width='28.5991' height='6.02086' transform='rotate(-90 112 147.599)' fill='white' />
      <rect
        x='122.021'
        y='147.599'
        width='28.5991'
        height='6.02086'
        transform='rotate(-90 122.021 147.599)'
        fill='white'
      />
      <rect
        x='139.331'
        y='147.599'
        width='28.5991'
        height='6.02086'
        transform='rotate(-90 139.331 147.599)'
        fill='white'
      />
      <rect
        x='133.31'
        y='135.558'
        width='5.26826'
        height='6.02086'
        transform='rotate(-90 133.31 135.558)'
        fill='white'
      />
      <rect
        x='127.289'
        y='129.537'
        width='5.26826'
        height='6.02086'
        transform='rotate(-90 127.289 129.537)'
        fill='white'
      />
      <rect x='153.488' y='119.3' width='15.9091' height='4.13636' fill='white' />
      <rect x='153.488' y='131.39' width='12.4091' height='4.13636' fill='white' />
      <rect x='149.67' y='143.163' width='16.2273' height='4.13636' fill='white' />
      <rect x='165.579' y='135.527' width='4.13636' height='7.63636' fill='white' />
      <rect x='149.352' y='123.118' width='4.45455' height='8.27273' fill='white' />
      <rect x='173.715' y='119.3' width='20.3636' height='4.13636' fill='white' />
      <rect x='181.67' y='123.436' width='4.77273' height='23.8636' fill='white' />
      <rect x='203.823' y='119.3' width='10.7693' height='5.74362' fill='white' />
      <rect x='203.823' y='130.787' width='11.4872' height='5.74362' fill='white' />
      <rect x='215.31' y='147.3' width='22.2565' height='5.74362' transform='rotate(-90 215.31 147.3)' fill='white' />
      <rect x='198.079' y='147.3' width='22.2565' height='5.74362' transform='rotate(-90 198.079 147.3)' fill='white' />
      <rect x='225.053' y='119.3' width='5' height='28' fill='white' />
      <rect x='230.053' y='142.3' width='14' height='5' fill='white' />
      <rect x='248.053' y='119.3' width='5' height='28' fill='white' />
      <rect x='253.053' y='142.3' width='14' height='5' fill='white' />
      <path
        d='M217.685 291.233C218.412 291.252 219.001 291.835 219.024 292.565L219.269 300.526C219.295 301.381 219.707 302.178 220.389 302.693L224.883 306.092C225.127 306.276 225.423 306.375 225.728 306.375C228.407 306.375 230.167 303.58 229.007 301.167L220.781 284.056C220.202 282.852 219.084 282 217.685 282C216.356 282 215.168 282.852 214.589 284.056L206.363 301.167C205.203 303.58 206.963 306.375 209.642 306.375C209.947 306.375 210.244 306.276 210.487 306.092L214.981 302.693C215.663 302.178 216.075 301.381 216.101 300.526L216.346 292.565C216.369 291.835 216.958 291.252 217.685 291.233Z'
        fill='white'
      />
      <path
        d='M92.2176 224.304V108.402H85.0678V112.918H79.047V118.939H73.4024V125.336H67.3815V246.882H74.9076V235.969H80.9285V230.325H86.573V224.304H92.2176Z'
        fill='#F14317'
      />
      <path
        d='M190.809 327.788V221.294H182.154V233.335H175.381V238.604H171.241V245.001H164.468V351.119H172.747V338.701H178.015V333.809H185.165V327.788H190.809Z'
        fill='#F14317'
      />
      <path
        d='M178.391 229.572V221.294H95.9806L95.6043 228.067H90.3361V234.088H84.6915V239.733H78.6707V246.882H160.705V241.238H167.478V234.841H172.37V229.949L178.391 229.572Z'
        fill='#6254FC'
      />
      <path
        d='M316.118 326.282H194.572L194.196 331.551H188.551V337.572H181.402V342.84H176.51V351.119H292.788V345.474H298.432V339.077H304.829V333.809H310.098V327.788H316.118V326.282Z'
        fill='#6254FC'
      />
      <rect x='296.927' y='269.084' width='6.77347' height='28.5991' fill='white' />
      <rect
        x='273.972'
        y='286.771'
        width='6.77347'
        height='6.02086'
        transform='rotate(-90 273.972 286.771)'
        fill='white'
      />
      <rect
        x='273.972'
        y='298.436'
        width='6.77347'
        height='29.3517'
        transform='rotate(-90 273.972 298.436)'
        fill='white'
      />
      <rect
        x='273.972'
        y='309.725'
        width='6.77347'
        height='6.02086'
        transform='rotate(-90 273.972 309.725)'
        fill='white'
      />
      <rect
        x='262.307'
        y='298.436'
        width='6.77347'
        height='6.02086'
        transform='rotate(-90 262.307 298.436)'
        fill='white'
      />
      <rect
        x='268.328'
        y='303.704'
        width='17.31'
        height='6.02086'
        transform='rotate(-90 268.328 303.704)'
        fill='white'
      />
      <path
        d='M74.4571 68.498L68.9271 70.9795L70.0551 73.4931L67.0388 74.8467L65.9108 72.3331L61.3863 74.3635L62.5143 76.8771L59.4979 78.2307L62.8819 85.7715L65.8982 84.4179L67.2518 87.4342L69.7654 86.3063L70.8934 88.8199L73.407 87.6919L74.535 90.2055L77.0486 89.0775L75.9206 86.5639L78.4342 85.4359L77.3063 82.9223L79.8199 81.7943L78.4663 78.778L81.4826 77.4244L80.5802 75.4135L77.5639 76.7671L76.3231 74.0021L73.8095 75.1301L72.3431 71.8624L75.3595 70.5088L74.4571 68.498Z'
        fill='#E7211C'
      />
      <path d='M78.0987 69.8836L79.2267 72.3972L76.713 73.5252L75.5851 71.0116L78.0987 69.8836Z' fill='#E7211C' />
      <rect
        x='72.3431'
        y='71.8625'
        width='3.30612'
        height='3.85714'
        transform='rotate(-24.1681 72.3431 71.8625)'
        fill='#F6EDDA'
      />
      <rect
        x='76.2103'
        y='73.7507'
        width='3.30612'
        height='3.30612'
        transform='rotate(-24.1681 76.2103 73.7507)'
        fill='#F6EDDA'
      />
      <g filter='url(#filter0_f_3383_11438)'>
        <rect
          x='61.3863'
          y='74.3635'
          width='4.95918'
          height='1.65306'
          transform='rotate(-24.1681 61.3863 74.3635)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter1_f_3383_11438)'>
        <rect
          x='68.9271'
          y='70.9795'
          width='6.06122'
          height='1.65306'
          transform='rotate(-24.1681 68.9271 70.9795)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter2_f_3383_11438)'>
        <rect
          x='77.5834'
          y='82.1941'
          width='2.20408'
          height='0.55102'
          transform='rotate(-24.1681 77.5834 82.1941)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter3_f_3383_11438)'>
        <rect
          x='74.567'
          y='83.5476'
          width='2.7551'
          height='3.30612'
          transform='rotate(-24.1681 74.567 83.5476)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter4_f_3383_11438)'>
        <rect
          x='74.0838'
          y='89.2002'
          width='2.7551'
          height='1.10204'
          transform='rotate(-24.1681 74.0838 89.2002)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter5_f_3383_11438)'>
        <rect
          x='70.4422'
          y='87.8145'
          width='2.7551'
          height='1.10204'
          transform='rotate(-24.1681 70.4422 87.8145)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter6_f_3383_11438)'>
        <rect
          x='67.0262'
          y='86.9316'
          width='2.7551'
          height='1.10204'
          transform='rotate(-24.1681 67.0262 86.9316)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter7_f_3383_11438)'>
        <rect
          x='78.5178'
          y='77.5469'
          width='2.7551'
          height='1.10204'
          transform='rotate(-24.1681 78.5178 77.5469)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter8_f_3383_11438)'>
        <rect
          x='59.498'
          y='78.2307'
          width='3.30612'
          height='8.26531'
          transform='rotate(-24.1681 59.498 78.2307)'
          fill='#A60400'
        />
      </g>
      <rect
        x='67.5735'
        y='67.9631'
        width='6.06122'
        height='3.30612'
        transform='rotate(-24.1681 67.5735 67.9631)'
        fill='black'
      />
      <rect
        x='74.2315'
        y='67.9954'
        width='3.30612'
        height='3.30612'
        transform='rotate(-24.1681 74.2315 67.9954)'
        fill='black'
      />
      <rect
        x='65.6852'
        y='71.8303'
        width='3.30612'
        height='3.30612'
        transform='rotate(-24.1681 65.6852 71.8303)'
        fill='black'
      />
      <rect
        x='58.1444'
        y='75.2144'
        width='3.30612'
        height='3.30612'
        transform='rotate(-24.1681 58.1444 75.2144)'
        fill='black'
      />
      <rect
        x='62.8819'
        y='85.7715'
        width='3.30612'
        height='3.30612'
        transform='rotate(-24.1681 62.8819 85.7715)'
        fill='black'
      />
      <rect
        x='66.7491'
        y='87.6599'
        width='3.30612'
        height='3.30612'
        transform='rotate(-24.1681 66.7491 87.6599)'
        fill='black'
      />
      <rect
        x='70.3907'
        y='89.0454'
        width='3.30612'
        height='3.30612'
        transform='rotate(-24.1681 70.3907 89.0454)'
        fill='black'
      />
      <rect
        x='74.535'
        y='90.2056'
        width='3.30612'
        height='3.30612'
        transform='rotate(-24.1681 74.535 90.2056)'
        fill='black'
      />
      <rect
        x='75.9206'
        y='86.564'
        width='3.30612'
        height='3.30612'
        transform='rotate(-24.1681 75.9206 86.564)'
        fill='black'
      />
      <rect
        x='77.3062'
        y='82.9224'
        width='3.30612'
        height='3.30612'
        transform='rotate(-24.1681 77.3062 82.9224)'
        fill='black'
      />
      <rect
        x='78.4663'
        y='78.7781'
        width='3.30612'
        height='3.30612'
        transform='rotate(-24.1681 78.4663 78.7781)'
        fill='black'
      />
      <rect
        x='56.4816'
        y='79.5842'
        width='3.30612'
        height='8.81633'
        transform='rotate(-24.1681 56.4816 79.5842)'
        fill='black'
      />
      <rect
        x='78.0987'
        y='69.8835'
        width='3.30612'
        height='8.81633'
        transform='rotate(-24.1681 78.0987 69.8835)'
        fill='black'
      />
      <rect
        x='59.53'
        y='71.5728'
        width='6.06122'
        height='3.30612'
        transform='rotate(-24.1681 59.53 71.5728)'
        fill='black'
      />
      <path
        d='M338.562 66.7924L329.89 64.8443L329.004 68.7863L324.274 67.7237L325.159 63.7817L318.064 62.1878L317.178 66.1298L312.448 65.0672L309.792 76.8931L314.522 77.9557L313.459 82.686L317.401 83.5715L316.516 87.5135L320.458 88.399L319.572 92.3409L323.514 93.2264L324.4 89.2844L328.342 90.1699L329.227 86.228L333.169 87.1135L334.232 82.3831L338.962 83.4457L339.67 80.2921L334.94 79.2295L335.914 74.8934L331.972 74.0079L333.123 68.8833L337.854 69.9459L338.562 66.7924Z'
        fill='#E7211C'
      />
      <path d='M341.618 71.6198L340.733 75.5618L336.791 74.6763L337.677 70.7343L341.618 71.6198Z' fill='#E7211C' />
      <rect
        x='333.123'
        y='68.8835'
        width='4.84823'
        height='5.65627'
        transform='rotate(12.6603 333.123 68.8835)'
        fill='#F6EDDA'
      />
      <rect
        x='336.003'
        y='74.4993'
        width='4.84823'
        height='4.84823'
        transform='rotate(12.6603 336.003 74.4993)'
        fill='#F6EDDA'
      />
      <g filter='url(#filter9_f_3383_11438)'>
        <rect
          x='318.064'
          y='62.1877'
          width='7.27234'
          height='2.42411'
          transform='rotate(12.6603 318.064 62.1877)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter10_f_3383_11438)'>
        <rect
          x='329.89'
          y='64.8442'
          width='8.88842'
          height='2.42411'
          transform='rotate(12.6603 329.89 64.8442)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter11_f_3383_11438)'>
        <rect
          x='330.193'
          y='85.6169'
          width='3.23215'
          height='0.808038'
          transform='rotate(12.6603 330.193 85.6169)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter12_f_3383_11438)'>
        <rect
          x='325.462'
          y='84.5542'
          width='4.04019'
          height='4.84823'
          transform='rotate(12.6603 325.462 84.5542)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter13_f_3383_11438)'>
        <rect
          x='319.926'
          y='90.7642'
          width='4.04019'
          height='1.61608'
          transform='rotate(12.6603 319.926 90.7642)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter14_f_3383_11438)'>
        <rect
          x='316.87'
          y='85.9365'
          width='4.04019'
          height='1.61608'
          transform='rotate(12.6603 316.87 85.9365)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter15_f_3383_11438)'>
        <rect
          x='313.636'
          y='81.8977'
          width='4.04019'
          height='1.61608'
          transform='rotate(12.6603 313.636 81.8977)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter16_f_3383_11438)'>
        <rect
          x='335.374'
          y='80.9834'
          width='4.04019'
          height='1.61608'
          transform='rotate(12.6603 335.374 80.9834)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter17_f_3383_11438)'>
        <rect
          x='312.448'
          y='65.0674'
          width='4.84823'
          height='12.1206'
          transform='rotate(12.6603 312.448 65.0674)'
          fill='#A60400'
        />
      </g>
      <rect
        x='330.952'
        y='60.1138'
        width='8.88842'
        height='4.84823'
        transform='rotate(12.6603 330.952 60.1138)'
        fill='black'
      />
      <rect
        x='338.739'
        y='66.0039'
        width='4.84823'
        height='4.84823'
        transform='rotate(12.6603 338.739 66.0039)'
        fill='black'
      />
      <rect
        x='325.336'
        y='62.9934'
        width='4.84823'
        height='4.84823'
        transform='rotate(12.6603 325.336 62.9934)'
        fill='black'
      />
      <rect
        x='313.511'
        y='60.3369'
        width='4.84823'
        height='4.84823'
        transform='rotate(12.6603 313.511 60.3369)'
        fill='black'
      />
      <rect
        x='309.791'
        y='76.8931'
        width='4.84823'
        height='4.84823'
        transform='rotate(12.6603 309.791 76.8931)'
        fill='black'
      />
      <rect
        x='312.671'
        y='82.509'
        width='4.84823'
        height='4.84823'
        transform='rotate(12.6603 312.671 82.509)'
        fill='black'
      />
      <rect
        x='315.727'
        y='87.3364'
        width='4.84823'
        height='4.84823'
        transform='rotate(12.6603 315.727 87.3364)'
        fill='black'
      />
      <rect
        x='319.572'
        y='92.3408'
        width='4.84823'
        height='4.84823'
        transform='rotate(12.6603 319.572 92.3408)'
        fill='black'
      />
      <rect
        x='324.4'
        y='89.2844'
        width='4.84823'
        height='4.84823'
        transform='rotate(12.6603 324.4 89.2844)'
        fill='black'
      />
      <rect
        x='329.227'
        y='86.228'
        width='4.84823'
        height='4.84823'
        transform='rotate(12.6603 329.227 86.228)'
        fill='black'
      />
      <rect
        x='334.232'
        y='82.3833'
        width='4.84823'
        height='4.84823'
        transform='rotate(12.6603 334.232 82.3833)'
        fill='black'
      />
      <rect
        x='307.718'
        y='64.0049'
        width='4.84823'
        height='12.9286'
        transform='rotate(12.6603 307.718 64.0049)'
        fill='black'
      />
      <rect
        x='341.619'
        y='71.6199'
        width='4.84823'
        height='12.9286'
        transform='rotate(12.6603 341.619 71.6199)'
        fill='black'
      />
      <rect
        x='318.338'
        y='57.2805'
        width='8.88842'
        height='4.84823'
        transform='rotate(12.6603 318.338 57.2805)'
        fill='black'
      />
      <path
        d='M356.653 206.214L352.209 205.215L351.756 207.235L349.332 206.691L349.785 204.671L346.149 203.854L345.696 205.874L343.272 205.33L341.911 211.389L344.334 211.934L343.79 214.358L345.81 214.812L345.356 216.832L347.376 217.285L346.922 219.305L348.942 219.759L349.396 217.739L351.416 218.193L351.87 216.173L353.89 216.627L354.434 214.203L356.858 214.747L357.221 213.131L354.797 212.587L355.296 210.365L353.276 209.911L353.866 207.285L356.29 207.83L356.653 206.214Z'
        fill='#E7211C'
      />
      <path d='M358.22 208.687L357.766 210.707L355.746 210.253L356.2 208.234L358.22 208.687Z' fill='#E7211C' />
      <rect
        x='353.866'
        y='207.285'
        width='2.48436'
        height='2.89842'
        transform='rotate(12.6603 353.866 207.285)'
        fill='#F6EDDA'
      />
      <rect
        x='355.342'
        y='210.163'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 355.342 210.163)'
        fill='#F6EDDA'
      />
      <g filter='url(#filter18_f_3383_11438)'>
        <rect
          x='346.149'
          y='203.854'
          width='3.72654'
          height='1.24218'
          transform='rotate(12.6603 346.149 203.854)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter19_f_3383_11438)'>
        <rect
          x='352.209'
          y='205.215'
          width='4.55467'
          height='1.24218'
          transform='rotate(12.6603 352.209 205.215)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter20_f_3383_11438)'>
        <rect
          x='352.365'
          y='215.86'
          width='1.65624'
          height='0.414061'
          transform='rotate(12.6603 352.365 215.86)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter21_f_3383_11438)'>
        <rect
          x='349.941'
          y='215.315'
          width='2.0703'
          height='2.48436'
          transform='rotate(12.6603 349.941 215.315)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter22_f_3383_11438)'>
        <rect
          x='347.104'
          y='218.497'
          width='2.0703'
          height='0.828121'
          transform='rotate(12.6603 347.104 218.497)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter23_f_3383_11438)'>
        <rect
          x='345.538'
          y='216.023'
          width='2.0703'
          height='0.828121'
          transform='rotate(12.6603 345.538 216.023)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter24_f_3383_11438)'>
        <rect
          x='343.881'
          y='213.954'
          width='2.0703'
          height='0.828121'
          transform='rotate(12.6603 343.881 213.954)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter25_f_3383_11438)'>
        <rect
          x='355.02'
          y='213.485'
          width='2.0703'
          height='0.828121'
          transform='rotate(12.6603 355.02 213.485)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter26_f_3383_11438)'>
        <rect
          x='343.272'
          y='205.33'
          width='2.48436'
          height='6.21091'
          transform='rotate(12.6603 343.272 205.33)'
          fill='#A60400'
        />
      </g>
      <rect
        x='352.754'
        y='202.791'
        width='4.55467'
        height='2.48436'
        transform='rotate(12.6603 352.754 202.791)'
        fill='black'
      />
      <rect
        x='356.744'
        y='205.81'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 356.744 205.81)'
        fill='black'
      />
      <rect
        x='349.876'
        y='204.267'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 349.876 204.267)'
        fill='black'
      />
      <rect
        x='343.816'
        y='202.906'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 343.816 202.906)'
        fill='black'
      />
      <rect
        x='341.911'
        y='211.389'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 341.911 211.389)'
        fill='black'
      />
      <rect
        x='343.386'
        y='214.267'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 343.386 214.267)'
        fill='black'
      />
      <rect
        x='344.952'
        y='216.741'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 344.952 216.741)'
        fill='black'
      />
      <rect
        x='346.922'
        y='219.305'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 346.922 219.305)'
        fill='black'
      />
      <rect
        x='349.396'
        y='217.739'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 349.396 217.739)'
        fill='black'
      />
      <rect
        x='351.87'
        y='216.173'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 351.87 216.173)'
        fill='black'
      />
      <rect
        x='354.434'
        y='214.203'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 354.434 214.203)'
        fill='black'
      />
      <rect
        x='340.848'
        y='204.785'
        width='2.48436'
        height='6.62497'
        transform='rotate(12.6603 340.848 204.785)'
        fill='black'
      />
      <rect
        x='358.22'
        y='208.687'
        width='2.48436'
        height='6.62497'
        transform='rotate(12.6603 358.22 208.687)'
        fill='black'
      />
      <rect
        x='346.29'
        y='201.339'
        width='4.55467'
        height='2.48436'
        transform='rotate(12.6603 346.29 201.339)'
        fill='black'
      />
      <path
        d='M327.163 356.872L322.719 355.874L322.265 357.894L319.842 357.35L320.295 355.33L316.659 354.513L316.206 356.533L313.782 355.988L312.42 362.048L314.844 362.593L314.3 365.017L316.32 365.471L315.866 367.491L317.886 367.944L317.432 369.964L319.452 370.418L319.906 368.398L321.926 368.852L322.38 366.832L324.4 367.286L324.944 364.862L327.368 365.406L327.731 363.79L325.307 363.246L325.806 361.024L323.786 360.57L324.376 357.944L326.8 358.488L327.163 356.872Z'
        fill='#E7211C'
      />
      <path d='M328.729 359.346L328.276 361.366L326.256 360.912L326.709 358.892L328.729 359.346Z' fill='#E7211C' />
      <rect
        x='324.376'
        y='357.944'
        width='2.48436'
        height='2.89842'
        transform='rotate(12.6603 324.376 357.944)'
        fill='#F6EDDA'
      />
      <rect
        x='325.852'
        y='360.822'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 325.852 360.822)'
        fill='#F6EDDA'
      />
      <g filter='url(#filter27_f_3383_11438)'>
        <rect
          x='316.659'
          y='354.513'
          width='3.72654'
          height='1.24218'
          transform='rotate(12.6603 316.659 354.513)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter28_f_3383_11438)'>
        <rect
          x='322.719'
          y='355.874'
          width='4.55467'
          height='1.24218'
          transform='rotate(12.6603 322.719 355.874)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter29_f_3383_11438)'>
        <rect
          x='322.874'
          y='366.519'
          width='1.65624'
          height='0.414061'
          transform='rotate(12.6603 322.874 366.519)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter30_f_3383_11438)'>
        <rect
          x='320.451'
          y='365.974'
          width='2.0703'
          height='2.48436'
          transform='rotate(12.6603 320.451 365.974)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter31_f_3383_11438)'>
        <rect
          x='317.614'
          y='369.156'
          width='2.0703'
          height='0.828121'
          transform='rotate(12.6603 317.614 369.156)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter32_f_3383_11438)'>
        <rect
          x='316.048'
          y='366.682'
          width='2.0703'
          height='0.828121'
          transform='rotate(12.6603 316.048 366.682)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter33_f_3383_11438)'>
        <rect
          x='314.391'
          y='364.613'
          width='2.0703'
          height='0.828121'
          transform='rotate(12.6603 314.391 364.613)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter34_f_3383_11438)'>
        <rect
          x='325.53'
          y='364.144'
          width='2.0703'
          height='0.828121'
          transform='rotate(12.6603 325.53 364.144)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter35_f_3383_11438)'>
        <rect
          x='313.782'
          y='355.989'
          width='2.48436'
          height='6.21091'
          transform='rotate(12.6603 313.782 355.989)'
          fill='#A60400'
        />
      </g>
      <rect
        x='323.264'
        y='353.45'
        width='4.55467'
        height='2.48436'
        transform='rotate(12.6603 323.264 353.45)'
        fill='black'
      />
      <rect
        x='327.254'
        y='356.469'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 327.254 356.469)'
        fill='black'
      />
      <rect
        x='320.386'
        y='354.926'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 320.386 354.926)'
        fill='black'
      />
      <rect
        x='314.326'
        y='353.564'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 314.326 353.564)'
        fill='black'
      />
      <rect
        x='312.42'
        y='362.048'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 312.42 362.048)'
        fill='black'
      />
      <rect
        x='313.896'
        y='364.926'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 313.896 364.926)'
        fill='black'
      />
      <rect
        x='315.462'
        y='367.4'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 315.462 367.4)'
        fill='black'
      />
      <rect
        x='317.432'
        y='369.964'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 317.432 369.964)'
        fill='black'
      />
      <rect
        x='319.906'
        y='368.398'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 319.906 368.398)'
        fill='black'
      />
      <rect
        x='322.38'
        y='366.832'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 322.38 366.832)'
        fill='black'
      />
      <rect
        x='324.944'
        y='364.862'
        width='2.48436'
        height='2.48436'
        transform='rotate(12.6603 324.944 364.862)'
        fill='black'
      />
      <rect
        x='311.358'
        y='355.444'
        width='2.48436'
        height='6.62497'
        transform='rotate(12.6603 311.358 355.444)'
        fill='black'
      />
      <rect
        x='328.729'
        y='359.346'
        width='2.48436'
        height='6.62497'
        transform='rotate(12.6603 328.729 359.346)'
        fill='black'
      />
      <rect
        x='316.8'
        y='351.998'
        width='4.55467'
        height='2.48436'
        transform='rotate(12.6603 316.8 351.998)'
        fill='black'
      />
      <path
        d='M143.186 271.706L139.355 270.845L138.964 272.587L136.874 272.118L137.265 270.376L134.13 269.672L133.739 271.413L131.649 270.944L130.476 276.168L132.566 276.638L132.096 278.728L133.838 279.119L133.446 280.86L135.188 281.252L134.797 282.993L136.538 283.384L136.929 281.643L138.671 282.034L139.062 280.293L140.804 280.684L141.273 278.594L143.363 279.063L143.676 277.67L141.586 277.201L142.016 275.285L140.275 274.894L140.783 272.63L142.873 273.099L143.186 271.706Z'
        fill='#E7211C'
      />
      <path d='M144.537 273.839L144.145 275.58L142.404 275.189L142.795 273.448L144.537 273.839Z' fill='#E7211C' />
      <rect
        x='140.783'
        y='272.63'
        width='2.1419'
        height='2.49888'
        transform='rotate(12.6603 140.783 272.63)'
        fill='#F6EDDA'
      />
      <rect
        x='142.056'
        y='275.111'
        width='2.1419'
        height='2.1419'
        transform='rotate(12.6603 142.056 275.111)'
        fill='#F6EDDA'
      />
      <g filter='url(#filter36_f_3383_11438)'>
        <rect
          x='134.13'
          y='269.672'
          width='3.21285'
          height='1.07095'
          transform='rotate(12.6603 134.13 269.672)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter37_f_3383_11438)'>
        <rect
          x='139.355'
          y='270.845'
          width='3.92681'
          height='1.07095'
          transform='rotate(12.6603 139.355 270.845)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter38_f_3383_11438)'>
        <rect
          x='139.489'
          y='280.023'
          width='1.42793'
          height='0.356983'
          transform='rotate(12.6603 139.489 280.023)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter39_f_3383_11438)'>
        <rect
          x='137.399'
          y='279.553'
          width='1.78491'
          height='2.1419'
          transform='rotate(12.6603 137.399 279.553)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter40_f_3383_11438)'>
        <rect
          x='134.953'
          y='282.296'
          width='1.78491'
          height='0.713966'
          transform='rotate(12.6603 134.953 282.296)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter41_f_3383_11438)'>
        <rect
          x='133.603'
          y='280.164'
          width='1.78491'
          height='0.713966'
          transform='rotate(12.6603 133.603 280.164)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter42_f_3383_11438)'>
        <rect
          x='132.174'
          y='278.379'
          width='1.78491'
          height='0.713966'
          transform='rotate(12.6603 132.174 278.379)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter43_f_3383_11438)'>
        <rect
          x='141.778'
          y='277.975'
          width='1.78491'
          height='0.713966'
          transform='rotate(12.6603 141.778 277.975)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter44_f_3383_11438)'>
        <rect
          x='131.649'
          y='270.944'
          width='2.1419'
          height='5.35474'
          transform='rotate(12.6603 131.649 270.944)'
          fill='#A60400'
        />
      </g>
      <rect
        x='139.824'
        y='268.755'
        width='3.92681'
        height='2.1419'
        transform='rotate(12.6603 139.824 268.755)'
        fill='black'
      />
      <rect
        x='143.264'
        y='271.358'
        width='2.1419'
        height='2.1419'
        transform='rotate(12.6603 143.264 271.358)'
        fill='black'
      />
      <rect
        x='137.343'
        y='270.028'
        width='2.1419'
        height='2.1419'
        transform='rotate(12.6603 137.343 270.028)'
        fill='black'
      />
      <rect
        x='132.119'
        y='268.854'
        width='2.1419'
        height='2.1419'
        transform='rotate(12.6603 132.119 268.854)'
        fill='black'
      />
      <rect
        x='130.476'
        y='276.168'
        width='2.1419'
        height='2.1419'
        transform='rotate(12.6603 130.476 276.168)'
        fill='black'
      />
      <rect
        x='131.748'
        y='278.649'
        width='2.1419'
        height='2.1419'
        transform='rotate(12.6603 131.748 278.649)'
        fill='black'
      />
      <rect
        x='133.098'
        y='280.782'
        width='2.1419'
        height='2.1419'
        transform='rotate(12.6603 133.098 280.782)'
        fill='black'
      />
      <rect
        x='134.797'
        y='282.993'
        width='2.1419'
        height='2.1419'
        transform='rotate(12.6603 134.797 282.993)'
        fill='black'
      />
      <rect
        x='136.929'
        y='281.643'
        width='2.1419'
        height='2.1419'
        transform='rotate(12.6603 136.929 281.643)'
        fill='black'
      />
      <rect
        x='139.062'
        y='280.292'
        width='2.1419'
        height='2.1419'
        transform='rotate(12.6603 139.062 280.292)'
        fill='black'
      />
      <rect
        x='141.273'
        y='278.594'
        width='2.1419'
        height='2.1419'
        transform='rotate(12.6603 141.273 278.594)'
        fill='black'
      />
      <rect
        x='129.559'
        y='270.475'
        width='2.1419'
        height='5.71173'
        transform='rotate(12.6603 129.559 270.475)'
        fill='black'
      />
      <rect
        x='144.537'
        y='273.839'
        width='2.1419'
        height='5.71173'
        transform='rotate(12.6603 144.537 273.839)'
        fill='black'
      />
      <rect
        x='134.251'
        y='267.504'
        width='3.92681'
        height='2.1419'
        transform='rotate(12.6603 134.251 267.504)'
        fill='black'
      />
      <path
        d='M62.9361 313.873L58.2244 317.697L59.9626 319.839L57.3926 321.925L55.6544 319.783L51.7993 322.912L53.5376 325.054L50.9676 327.14L56.1824 333.565L58.7525 331.479L60.8384 334.049L62.9801 332.311L64.7183 334.452L66.86 332.714L68.5983 334.856L70.74 333.117L69.0017 330.976L71.1434 329.237L69.4051 327.096L71.5467 325.357L69.4608 322.787L72.0308 320.702L70.6402 318.988L68.0702 321.074L66.1581 318.718L64.0164 320.457L61.7567 317.672L64.3267 315.586L62.9361 313.873Z'
        fill='#E7211C'
      />
      <path d='M66.816 314.276L68.5543 316.418L66.4126 318.156L64.6743 316.015L66.816 314.276Z' fill='#E7211C' />
      <rect
        x='61.7567'
        y='317.672'
        width='3.30999'
        height='3.86166'
        transform='rotate(-39.0643 61.7567 317.672)'
        fill='#F6EDDA'
      />
      <rect
        x='65.9843'
        y='318.504'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 65.9843 318.504)'
        fill='#F6EDDA'
      />
      <g filter='url(#filter45_f_3383_11438)'>
        <rect
          x='51.7991'
          y='322.912'
          width='4.96499'
          height='1.655'
          transform='rotate(-39.0643 51.7991 322.912)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter46_f_3383_11438)'>
        <rect
          x='58.2244'
          y='317.697'
          width='6.06832'
          height='1.655'
          transform='rotate(-39.0643 58.2244 317.697)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter47_f_3383_11438)'>
        <rect
          x='69.486'
          y='326.32'
          width='2.20666'
          height='0.551665'
          transform='rotate(-39.0643 69.486 326.32)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter48_f_3383_11438)'>
        <rect
          x='66.9157'
          y='328.406'
          width='2.75833'
          height='3.30999'
          transform='rotate(-39.0643 66.9157 328.406)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter49_f_3383_11438)'>
        <rect
          x='67.9028'
          y='333.999'
          width='2.75833'
          height='1.10333'
          transform='rotate(-39.0643 67.9028 333.999)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter50_f_3383_11438)'>
        <rect
          x='64.0227'
          y='333.595'
          width='2.75833'
          height='1.10333'
          transform='rotate(-39.0643 64.0227 333.595)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter51_f_3383_11438)'>
        <rect
          x='60.4907'
          y='333.62'
          width='2.75833'
          height='1.10333'
          transform='rotate(-39.0643 60.4907 333.62)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter52_f_3383_11438)'>
        <rect
          x='69.1936'
          y='321.583'
          width='2.75833'
          height='1.10333'
          transform='rotate(-39.0643 69.1936 321.583)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter53_f_3383_11438)'>
        <rect
          x='50.9676'
          y='327.139'
          width='3.30999'
          height='8.27498'
          transform='rotate(-39.0643 50.9676 327.139)'
          fill='#A60400'
        />
      </g>
      <rect
        x='56.1381'
        y='315.127'
        width='6.06832'
        height='3.30999'
        transform='rotate(-39.0643 56.1381 315.127)'
        fill='black'
      />
      <rect
        x='62.5882'
        y='313.445'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 62.5882 313.445)'
        fill='black'
      />
      <rect
        x='55.3066'
        y='319.355'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 55.3066 319.355)'
        fill='black'
      />
      <rect
        x='48.8816'
        y='324.57'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 48.8816 324.57)'
        fill='black'
      />
      <rect
        x='56.1824'
        y='333.565'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 56.1824 333.565)'
        fill='black'
      />
      <rect
        x='60.41'
        y='334.396'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 60.41 334.396)'
        fill='black'
      />
      <rect
        x='64.29'
        y='334.8'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 64.29 334.8)'
        fill='black'
      />
      <rect
        x='68.598'
        y='334.855'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 68.598 334.855)'
        fill='black'
      />
      <rect
        x='69.0016'
        y='330.976'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 69.0016 330.976)'
        fill='black'
      />
      <rect
        x='69.405'
        y='327.095'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 69.405 327.095)'
        fill='black'
      />
      <rect
        x='69.4609'
        y='322.787'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 69.4609 322.787)'
        fill='black'
      />
      <rect
        x='48.3977'
        y='329.226'
        width='3.30999'
        height='8.82665'
        transform='rotate(-39.0643 48.3977 329.226)'
        fill='black'
      />
      <rect
        x='66.8158'
        y='314.276'
        width='3.30999'
        height='8.82665'
        transform='rotate(-39.0643 66.8158 314.276)'
        fill='black'
      />
      <rect
        x='49.285'
        y='320.689'
        width='6.06832'
        height='3.30999'
        transform='rotate(-39.0643 49.285 320.689)'
        fill='black'
      />
      <path
        d='M43.3627 177.395L38.6511 181.219L40.3893 183.36L37.8193 185.446L36.0811 183.305L32.226 186.434L33.9643 188.575L31.3943 190.661L36.6091 197.086L39.1791 195L41.2651 197.57L43.4068 195.832L45.145 197.974L47.2867 196.235L49.025 198.377L51.1667 196.639L49.4284 194.497L51.57 192.759L49.8318 190.617L51.9734 188.879L49.8875 186.309L52.4575 184.223L51.0669 182.51L48.4969 184.596L46.5848 182.24L44.4431 183.978L42.1834 181.194L44.7534 179.108L43.3627 177.395Z'
        fill='#E7211C'
      />
      <path d='M47.2427 177.798L48.981 179.94L46.8393 181.678L45.101 179.536L47.2427 177.798Z' fill='#E7211C' />
      <rect
        x='42.1834'
        y='181.194'
        width='3.30999'
        height='3.86166'
        transform='rotate(-39.0643 42.1834 181.194)'
        fill='#F6EDDA'
      />
      <rect
        x='46.411'
        y='182.025'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 46.411 182.025)'
        fill='#F6EDDA'
      />
      <g filter='url(#filter54_f_3383_11438)'>
        <rect
          x='32.2258'
          y='186.433'
          width='4.96499'
          height='1.655'
          transform='rotate(-39.0643 32.2258 186.433)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter55_f_3383_11438)'>
        <rect
          x='38.6511'
          y='181.219'
          width='6.06832'
          height='1.655'
          transform='rotate(-39.0643 38.6511 181.219)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter56_f_3383_11438)'>
        <rect
          x='49.9127'
          y='189.841'
          width='2.20666'
          height='0.551665'
          transform='rotate(-39.0643 49.9127 189.841)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter57_f_3383_11438)'>
        <rect
          x='47.3424'
          y='191.927'
          width='2.75833'
          height='3.30999'
          transform='rotate(-39.0643 47.3424 191.927)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter58_f_3383_11438)'>
        <rect
          x='48.3295'
          y='197.52'
          width='2.75833'
          height='1.10333'
          transform='rotate(-39.0643 48.3295 197.52)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter59_f_3383_11438)'>
        <rect
          x='44.4494'
          y='197.117'
          width='2.75833'
          height='1.10333'
          transform='rotate(-39.0643 44.4494 197.117)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter60_f_3383_11438)'>
        <rect
          x='40.9174'
          y='197.142'
          width='2.75833'
          height='1.10333'
          transform='rotate(-39.0643 40.9174 197.142)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter61_f_3383_11438)'>
        <rect
          x='49.6203'
          y='185.104'
          width='2.75833'
          height='1.10333'
          transform='rotate(-39.0643 49.6203 185.104)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter62_f_3383_11438)'>
        <rect
          x='31.3943'
          y='190.661'
          width='3.30999'
          height='8.27498'
          transform='rotate(-39.0643 31.3943 190.661)'
          fill='#A60400'
        />
      </g>
      <rect
        x='36.5648'
        y='178.648'
        width='6.06832'
        height='3.30999'
        transform='rotate(-39.0643 36.5648 178.648)'
        fill='black'
      />
      <rect
        x='43.0149'
        y='176.966'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 43.0149 176.966)'
        fill='black'
      />
      <rect
        x='35.7333'
        y='182.876'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 35.7333 182.876)'
        fill='black'
      />
      <rect
        x='29.3083'
        y='188.091'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 29.3083 188.091)'
        fill='black'
      />
      <rect
        x='36.6091'
        y='197.086'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 36.6091 197.086)'
        fill='black'
      />
      <rect
        x='40.8367'
        y='197.918'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 40.8367 197.918)'
        fill='black'
      />
      <rect
        x='44.7167'
        y='198.321'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 44.7167 198.321)'
        fill='black'
      />
      <rect
        x='49.0247'
        y='198.377'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 49.0247 198.377)'
        fill='black'
      />
      <rect
        x='49.4283'
        y='194.497'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 49.4283 194.497)'
        fill='black'
      />
      <rect
        x='49.8317'
        y='190.617'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 49.8317 190.617)'
        fill='black'
      />
      <rect
        x='49.8876'
        y='186.309'
        width='3.30999'
        height='3.30999'
        transform='rotate(-39.0643 49.8876 186.309)'
        fill='black'
      />
      <rect
        x='28.8244'
        y='192.747'
        width='3.30999'
        height='8.82665'
        transform='rotate(-39.0643 28.8244 192.747)'
        fill='black'
      />
      <rect
        x='47.2425'
        y='177.798'
        width='3.30999'
        height='8.82665'
        transform='rotate(-39.0643 47.2425 177.798)'
        fill='black'
      />
      <rect
        x='29.7117'
        y='184.211'
        width='6.06832'
        height='3.30999'
        transform='rotate(-39.0643 29.7117 184.211)'
        fill='black'
      />
      <defs>
        <filter
          id='filter0_f_3383_11438'
          x='58.7965'
          y='69.7435'
          width='10.3809'
          height='8.71792'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.2949' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter1_f_3383_11438'
          x='66.3373'
          y='65.9083'
          width='11.3863'
          height='9.16909'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.2949' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter2_f_3383_11438'
          x='76.5915'
          y='80.2999'
          width='4.22015'
          height='3.3887'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter3_f_3383_11438'
          x='73.5752'
          y='81.4278'
          width='5.85086'
          height='6.12796'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter4_f_3383_11438'
          x='73.092'
          y='87.0804'
          width='4.94849'
          height='4.11697'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter5_f_3383_11438'
          x='69.4504'
          y='85.6947'
          width='4.94849'
          height='4.11697'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter6_f_3383_11438'
          x='66.0344'
          y='84.8119'
          width='4.94849'
          height='4.11697'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter7_f_3383_11438'
          x='77.526'
          y='75.4271'
          width='4.94849'
          height='4.11697'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter8_f_3383_11438'
          x='56.9082'
          y='74.2874'
          width='11.5799'
          height='14.0739'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.2949' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter9_f_3383_11438'
          x='313.735'
          y='58.39'
          width='15.2224'
          height='11.5545'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.89889' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter10_f_3383_11438'
          x='325.561'
          y='61.0465'
          width='16.7992'
          height='11.9088'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.89889' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter11_f_3383_11438'
          x='328.561'
          y='84.1625'
          width='6.2396'
          height='4.40576'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter12_f_3383_11438'
          x='322.945'
          y='83.0997'
          width='7.91348'
          height='8.52466'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter13_f_3383_11438'
          x='318.118'
          y='89.3097'
          width='7.2051'
          height='5.3711'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter14_f_3383_11438'
          x='315.061'
          y='84.4821'
          width='7.2051'
          height='5.3711'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter15_f_3383_11438'
          x='311.828'
          y='80.4432'
          width='7.2051'
          height='5.3711'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter16_f_3383_11438'
          x='333.566'
          y='79.5289'
          width='7.2051'
          height='5.3711'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter17_f_3383_11438'
          x='305.994'
          y='61.2696'
          width='14.9824'
          height='20.484'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.89889' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter18_f_3383_11438'
          x='343.931'
          y='201.908'
          width='7.80036'
          height='5.92098'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter19_f_3383_11438'
          x='349.991'
          y='203.269'
          width='8.60834'
          height='6.10237'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter20_f_3383_11438'
          x='351.529'
          y='215.115'
          width='3.19734'
          height='2.25771'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter21_f_3383_11438'
          x='348.651'
          y='214.57'
          width='4.05508'
          height='4.3683'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter22_f_3383_11438'
          x='346.177'
          y='217.752'
          width='3.69208'
          height='2.75234'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter23_f_3383_11438'
          x='344.611'
          y='215.278'
          width='3.69208'
          height='2.75234'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter24_f_3383_11438'
          x='342.954'
          y='213.209'
          width='3.69208'
          height='2.75234'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter25_f_3383_11438'
          x='354.093'
          y='212.74'
          width='3.69208'
          height='2.75234'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter26_f_3383_11438'
          x='339.964'
          y='203.384'
          width='7.67737'
          height='10.4967'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter27_f_3383_11438'
          x='314.441'
          y='352.567'
          width='7.80036'
          height='5.92098'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter28_f_3383_11438'
          x='320.501'
          y='353.928'
          width='8.60834'
          height='6.10237'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter29_f_3383_11438'
          x='322.038'
          y='365.773'
          width='3.19733'
          height='2.25771'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter30_f_3383_11438'
          x='319.161'
          y='365.229'
          width='4.05509'
          height='4.3683'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter31_f_3383_11438'
          x='316.687'
          y='368.411'
          width='3.6921'
          height='2.75234'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter32_f_3383_11438'
          x='315.121'
          y='365.937'
          width='3.6921'
          height='2.75234'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter33_f_3383_11438'
          x='313.464'
          y='363.867'
          width='3.6921'
          height='2.75234'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter34_f_3383_11438'
          x='324.603'
          y='363.399'
          width='3.6921'
          height='2.75234'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter35_f_3383_11438'
          x='310.474'
          y='354.042'
          width='7.67737'
          height='10.4967'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter36_f_3383_11438'
          x='132.218'
          y='267.994'
          width='6.72508'
          height='5.10466'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.83891' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter37_f_3383_11438'
          x='137.442'
          y='269.168'
          width='7.42168'
          height='5.26116'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.83891' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter38_f_3383_11438'
          x='138.768'
          y='279.38'
          width='2.7566'
          height='1.94652'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter39_f_3383_11438'
          x='136.287'
          y='278.91'
          width='3.49611'
          height='3.7661'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter40_f_3383_11438'
          x='134.154'
          y='281.654'
          width='3.18315'
          height='2.37303'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter41_f_3383_11438'
          x='132.804'
          y='279.521'
          width='3.18315'
          height='2.37303'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter42_f_3383_11438'
          x='131.375'
          y='277.737'
          width='3.18315'
          height='2.37303'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter43_f_3383_11438'
          x='140.979'
          y='277.333'
          width='3.18315'
          height='2.37303'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter44_f_3383_11438'
          x='128.798'
          y='269.266'
          width='6.61904'
          height='9.04973'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.83891' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter45_f_3383_11438'
          x='49.2063'
          y='317.19'
          width='10.0836'
          height='9.59947'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter46_f_3383_11438'
          x='55.6316'
          y='311.28'
          width='10.9403'
          height='10.2948'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter47_f_3383_11438'
          x='68.493'
          y='323.936'
          width='4.047'
          height='3.80484'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter48_f_3383_11438'
          x='65.9227'
          y='325.674'
          width='6.2136'
          height='6.29435'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter49_f_3383_11438'
          x='66.9098'
          y='331.268'
          width='4.82297'
          height='4.58097'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter50_f_3383_11438'
          x='63.0297'
          y='330.864'
          width='4.82297'
          height='4.58097'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter51_f_3383_11438'
          x='59.4977'
          y='330.889'
          width='4.82297'
          height='4.58097'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter52_f_3383_11438'
          x='68.2006'
          y='318.851'
          width='4.82297'
          height='4.58097'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter53_f_3383_11438'
          x='48.3747'
          y='322.461'
          width='12.9705'
          height='13.6966'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter54_f_3383_11438'
          x='29.633'
          y='180.712'
          width='10.0836'
          height='9.59947'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter55_f_3383_11438'
          x='36.0583'
          y='174.802'
          width='10.9403'
          height='10.2948'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter56_f_3383_11438'
          x='48.9197'
          y='187.458'
          width='4.047'
          height='3.80484'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter57_f_3383_11438'
          x='46.3494'
          y='189.196'
          width='6.2136'
          height='6.29435'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter58_f_3383_11438'
          x='47.3365'
          y='194.789'
          width='4.82297'
          height='4.58097'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter59_f_3383_11438'
          x='43.4564'
          y='194.385'
          width='4.82297'
          height='4.58097'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter60_f_3383_11438'
          x='39.9244'
          y='194.411'
          width='4.82297'
          height='4.58097'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter61_f_3383_11438'
          x='48.6273'
          y='182.373'
          width='4.82297'
          height='4.58097'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_11438' />
        </filter>
        <filter
          id='filter62_f_3383_11438'
          x='28.8014'
          y='185.982'
          width='12.9705'
          height='13.6966'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_11438' />
        </filter>
      </defs>
    </svg>
  )
}
function OnboardImage4Light() {
  return (
    <svg style={{ width: '100%' }} viewBox='0 0 390 409' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M297.657 90.0962H95.9674M95.9674 90.0962H92.2115V96.1075H85.0754V100.616H79.066V106.627H73.4322V113.014H67.4228V238.125H78.6904M95.9674 90.0962V208.82M95.9674 208.82H181.977M95.9674 208.82V215.583H90.3336V221.594H84.6998V227.229H78.6904V238.125M194.371 313.642V208.82H181.977M194.371 313.642H319.441M194.371 313.642V318.902H188.362V324.913H181.226V330.173H176.343V342.196M319.441 313.642V113.014M319.441 313.642V318.902H313.432V324.913H308.174V330.173H301.789V336.56H296.155V342.196M297.657 342.196H296.155M164.324 238.125V342.196H176.343M164.324 238.125V232.489H171.085V226.102H175.592V220.842H181.977V208.82M164.324 238.125H78.6904M296.155 342.196H176.343'
        stroke='#F0F0F0'
        strokeWidth='3.76304'
      />
      <rect x='299.536' y='92.7269' width='5.25678' height='4.5073' stroke='#F0F0F0' strokeWidth='0.752608' />
      <rect x='305.545' y='98.7386' width='5.25678' height='4.5073' stroke='#F0F0F0' strokeWidth='0.752608' />
      <rect x='310.804' y='103.998' width='5.25678' height='4.5073' stroke='#F0F0F0' strokeWidth='0.752608' />
      <path
        d='M299.16 91.9746C233.182 92.2251 99.6481 91.9746 97.8453 91.9746V206.941H196.249V311.764L316.437 311.012L317.563 112.639L316.437 108.881H310.427V103.622H305.31V98.3616L305.169 97.6102H302.164H299.16V94.6046V91.9746Z'
        fill='#391998'
        stroke='#F0F0F0'
        strokeWidth='0.752608'
      />
      <rect
        x='113.834'
        y='137.166'
        width='28.5991'
        height='6.02086'
        transform='rotate(-90 113.834 137.166)'
        fill='white'
      />
      <rect
        x='123.855'
        y='137.166'
        width='28.5991'
        height='6.02086'
        transform='rotate(-90 123.855 137.166)'
        fill='white'
      />
      <rect
        x='141.165'
        y='137.166'
        width='28.5991'
        height='6.02086'
        transform='rotate(-90 141.165 137.166)'
        fill='white'
      />
      <rect
        x='135.144'
        y='125.125'
        width='5.26826'
        height='6.02086'
        transform='rotate(-90 135.144 125.125)'
        fill='white'
      />
      <rect
        x='129.123'
        y='119.104'
        width='5.26826'
        height='6.02086'
        transform='rotate(-90 129.123 119.104)'
        fill='white'
      />
      <rect x='155.322' y='108.866' width='15.9091' height='4.13636' fill='white' />
      <rect x='155.322' y='120.957' width='12.4091' height='4.13636' fill='white' />
      <rect x='151.504' y='132.73' width='16.2273' height='4.13636' fill='white' />
      <rect x='167.413' y='125.093' width='4.13636' height='7.63636' fill='white' />
      <rect x='151.186' y='112.685' width='4.45455' height='8.27273' fill='white' />
      <rect x='175.549' y='108.867' width='20.3636' height='4.13636' fill='white' />
      <rect x='183.504' y='113.003' width='4.77273' height='23.8636' fill='white' />
      <rect x='205.657' y='108.866' width='10.7693' height='5.74362' fill='white' />
      <rect x='205.657' y='120.354' width='11.4872' height='5.74362' fill='white' />
      <rect
        x='217.144'
        y='136.866'
        width='22.2565'
        height='5.74362'
        transform='rotate(-90 217.144 136.866)'
        fill='white'
      />
      <rect
        x='199.913'
        y='136.866'
        width='22.2565'
        height='5.74362'
        transform='rotate(-90 199.913 136.866)'
        fill='white'
      />
      <rect x='226.887' y='108.866' width='5' height='28' fill='white' />
      <rect x='231.887' y='131.866' width='14' height='5' fill='white' />
      <rect x='249.887' y='108.866' width='5' height='28' fill='white' />
      <rect x='254.887' y='131.866' width='14' height='5' fill='white' />
      <path
        d='M219.318 280.527C220.043 280.546 220.631 281.128 220.654 281.857L220.898 289.806C220.925 290.659 221.336 291.454 222.017 291.969L226.502 295.362C226.745 295.546 227.041 295.645 227.346 295.645C230.019 295.645 231.776 292.854 230.618 290.446L222.408 273.362C221.83 272.159 220.714 271.309 219.318 271.309C217.991 271.309 216.805 272.159 216.227 273.362L208.017 290.446C206.86 292.854 208.616 295.645 211.29 295.645C211.594 295.645 211.89 295.546 212.133 295.362L216.619 291.969C217.3 291.454 217.711 290.659 217.737 289.806L217.982 281.857C218.004 281.128 218.592 280.546 219.318 280.527Z'
        fill='white'
      />
      <path
        d='M94.0895 213.704V97.9863H86.9533V102.495H80.9439V108.506H75.3101V114.893H69.3008V236.247H76.8125V225.351H82.8219V219.716H88.4557V213.704H94.0895Z'
        fill='#F14317'
        stroke='#F0F0F0'
        strokeWidth='0.752608'
      />
      <path
        d='M192.493 317.024V210.698H183.855V222.721H177.094V227.981H172.963V234.368H166.202V340.317H174.465V327.919H179.723V323.035H186.859V317.024H192.493Z'
        fill='#F14317'
        stroke='#F0F0F0'
        strokeWidth='0.752608'
      />
      <path
        d='M180.099 218.964V210.698H97.8453L97.4697 217.461H92.2115V223.472H86.5777V229.108H80.5683V236.246H162.446V230.611H169.207V224.224H174.089V219.34L180.099 218.964Z'
        fill='#6254FC'
        stroke='#F0F0F0'
        strokeWidth='0.752608'
      />
      <path
        d='M317.564 315.521H196.249L195.873 320.781H190.24V326.792H183.104V332.052H178.221V340.318H294.277V334.682H299.911V328.295H306.296V323.035H311.554V317.024H317.564V315.521Z'
        fill='#6254FC'
        stroke='#F0F0F0'
        strokeWidth='0.752608'
      />
      <rect x='298.409' y='258.413' width='6.76056' height='28.5538' fill='white' />
      <rect
        x='275.498'
        y='276.072'
        width='6.76274'
        height='6.00939'
        transform='rotate(-90 275.498 276.072)'
        fill='white'
      />
      <rect
        x='275.498'
        y='287.719'
        width='6.76274'
        height='29.2958'
        transform='rotate(-90 275.498 287.719)'
        fill='white'
      />
      <rect
        x='275.498'
        y='298.99'
        width='6.76274'
        height='6.00939'
        transform='rotate(-90 275.498 298.99)'
        fill='white'
      />
      <rect
        x='263.855'
        y='287.719'
        width='6.76274'
        height='6.00939'
        transform='rotate(-90 263.855 287.719)'
        fill='white'
      />
      <rect
        x='269.864'
        y='292.979'
        width='17.2826'
        height='6.00939'
        transform='rotate(-90 269.864 292.979)'
        fill='white'
      />
      <path
        d='M76.3628 58.1454L70.8434 60.623L71.9692 63.1326L68.9586 64.4841L67.8328 61.9744L63.3169 64.0016L64.4428 66.5112L61.4322 67.8627L64.8097 75.3915L67.8202 74.0401L69.1712 77.0517L71.6801 75.9255L72.8059 78.4351L75.3147 77.3089L76.4405 79.8185L78.9494 78.6923L77.8235 76.1827L80.3324 75.0565L79.2065 72.5469L81.7153 71.4207L80.3643 68.4091L83.3749 67.0577L82.4743 65.05L79.4637 66.4014L78.2253 63.6408L75.7164 64.767L74.2529 61.5045L77.2634 60.1531L76.3628 58.1454Z'
        fill='#E7211C'
      />
      <path d='M79.9974 59.5288L81.1233 62.0384L78.6144 63.1646L77.4886 60.655L79.9974 59.5288Z' fill='#E7211C' />
      <rect
        width='3.3'
        height='3.85082'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 74.2529 61.5039)'
        fill='#F6EDDA'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 78.1127 63.3896)'
        fill='#F6EDDA'
      />
      <g filter='url(#filter0_f_3383_10233)'>
        <rect
          width='4.95'
          height='1.65035'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 63.3169 64.001)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter1_f_3383_10233)'>
        <rect
          width='6.05'
          height='1.65035'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 70.8434 60.6226)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter2_f_3383_10233)'>
        <rect
          width='2.20058'
          height='0.550844'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 79.4831 71.8193)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter3_f_3383_10233)'>
        <rect
          width='2.75'
          height='3.3007'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 76.4726 73.1704)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter4_f_3383_10233)'>
        <rect
          width='2.75'
          height='1.10023'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 75.9902 78.8145)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter5_f_3383_10233)'>
        <rect
          width='2.75'
          height='1.10023'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 72.3556 77.4312)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter6_f_3383_10233)'>
        <rect
          width='2.75'
          height='1.10023'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 68.9461 76.5493)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter7_f_3383_10233)'>
        <rect
          width='2.75'
          height='1.10023'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 80.4158 67.1797)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter8_f_3383_10233)'>
        <rect
          width='3.3'
          height='8.25176'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 61.4322 67.8623)'
          fill='#A60400'
        />
      </g>
      <rect
        width='6.05'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 69.4924 57.6113)'
        fill='#F0F0F0'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 76.1376 57.6431)'
        fill='#F0F0F0'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 67.6077 61.4722)'
        fill='#F0F0F0'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 60.0812 64.8506)'
        fill='#F0F0F0'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 64.8097 75.3911)'
        fill='#F0F0F0'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 68.6695 77.2764)'
        fill='#F0F0F0'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 72.3042 78.6602)'
        fill='#F0F0F0'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 76.4406 79.8184)'
        fill='#F0F0F0'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 77.8235 76.1826)'
        fill='#F0F0F0'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 79.2065 72.5464)'
        fill='#F0F0F0'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 80.3643 68.4087)'
        fill='#F0F0F0'
      />
      <rect
        width='3.3'
        height='8.80188'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 58.4216 69.2139)'
        fill='#F0F0F0'
      />
      <rect
        width='3.3'
        height='8.80188'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 79.9974 59.5288)'
        fill='#F0F0F0'
      />
      <rect
        width='6.05'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 61.4642 61.2148)'
        fill='#F0F0F0'
      />
      <path
        d='M339.964 56.4418L331.308 54.4968L330.425 58.4326L325.703 57.3717L326.587 53.4359L319.505 51.8446L318.621 55.7803L313.9 54.7194L311.249 66.5265L315.97 67.5874L314.909 72.3103L318.844 73.1944L317.96 77.1301L321.894 78.0142L321.011 81.9499L324.945 82.834L325.829 78.8983L329.763 79.7823L330.647 75.8466L334.582 76.7307L335.642 72.0079L340.363 73.0688L341.071 69.9202L336.349 68.8593L337.321 64.53L333.387 63.6459L334.536 58.5295L339.257 59.5904L339.964 56.4418Z'
        fill='#E7211C'
      />
      <path d='M343.015 61.2616L342.131 65.1973L338.197 64.3133L339.08 60.3775L343.015 61.2616Z' fill='#E7211C' />
      <rect
        width='4.83906'
        height='5.64722'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 334.536 58.5298)'
        fill='#F6EDDA'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 337.41 64.1367)'
        fill='#F6EDDA'
      />
      <g filter='url(#filter9_f_3383_10233)'>
        <rect
          width='7.25859'
          height='2.42023'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 319.505 51.8447)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter10_f_3383_10233)'>
        <rect
          width='8.87161'
          height='2.42023'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 331.308 54.4971)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter11_f_3383_10233)'>
        <rect
          width='3.22604'
          height='0.806745'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 331.611 75.2368)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter12_f_3383_10233)'>
        <rect
          width='4.03255'
          height='4.84047'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 326.889 74.1758)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter13_f_3383_10233)'>
        <rect
          width='4.03255'
          height='1.61349'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 321.364 80.3755)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter14_f_3383_10233)'>
        <rect
          width='4.03255'
          height='1.61349'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 318.314 75.5562)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter15_f_3383_10233)'>
        <rect
          width='4.03255'
          height='1.61349'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 315.086 71.5234)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter16_f_3383_10233)'>
        <rect
          width='4.03255'
          height='1.61349'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 336.783 70.6108)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter17_f_3383_10233)'>
        <rect
          width='4.83906'
          height='12.1012'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 313.9 54.7192)'
          fill='#A60400'
        />
      </g>
      <rect
        width='8.87161'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 332.369 49.7739)'
        fill='#F0F0F0'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 340.141 55.6548)'
        fill='#F0F0F0'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 326.764 52.6489)'
        fill='#F0F0F0'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 314.961 49.9966)'
        fill='#F0F0F0'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 311.249 66.5264)'
        fill='#F0F0F0'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 314.123 72.1338)'
        fill='#F0F0F0'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 317.173 76.9531)'
        fill='#F0F0F0'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 321.011 81.9497)'
        fill='#F0F0F0'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 325.829 78.8984)'
        fill='#F0F0F0'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 330.647 75.8467)'
        fill='#F0F0F0'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 335.642 72.0078)'
        fill='#F0F0F0'
      />
      <rect
        width='4.83906'
        height='12.9079'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 309.179 53.6587)'
        fill='#F0F0F0'
      />
      <rect
        width='4.83906'
        height='12.9079'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 343.015 61.2617)'
        fill='#F0F0F0'
      />
      <rect
        width='8.87161'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 319.779 46.9453)'
        fill='#F0F0F0'
      />
      <path
        d='M358.021 195.642L353.586 194.645L353.133 196.662L350.713 196.119L351.166 194.102L347.537 193.286L347.084 195.303L344.665 194.759L343.306 200.81L345.726 201.353L345.182 203.773L347.198 204.227L346.745 206.243L348.762 206.696L348.309 208.713L350.325 209.166L350.778 207.149L352.794 207.602L353.247 205.586L355.263 206.039L355.806 203.619L358.226 204.162L358.588 202.549L356.169 202.005L356.667 199.787L354.651 199.334L355.239 196.712L357.659 197.255L358.021 195.642Z'
        fill='#E7211C'
      />
      <path d='M359.584 198.112L359.131 200.129L357.115 199.676L357.568 197.659L359.584 198.112Z' fill='#E7211C' />
      <rect
        width='2.47967'
        height='2.89379'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 355.239 196.712)'
        fill='#F6EDDA'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 356.712 199.585)'
        fill='#F6EDDA'
      />
      <g filter='url(#filter18_f_3383_10233)'>
        <rect
          width='3.7195'
          height='1.24019'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 347.537 193.287)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter19_f_3383_10233)'>
        <rect
          width='4.54605'
          height='1.24019'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 353.586 194.646)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter20_f_3383_10233)'>
        <rect
          width='1.65324'
          height='0.414023'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 353.741 205.273)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter21_f_3383_10233)'>
        <rect
          width='2.06639'
          height='2.48039'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 351.321 204.729)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter22_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 348.49 207.906)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter23_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 346.927 205.437)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter24_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 345.273 203.37)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter25_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 356.391 202.903)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter26_f_3383_10233)'>
        <rect
          width='2.47967'
          height='6.20097'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 344.665 194.76)'
          fill='#A60400'
        />
      </g>
      <rect
        width='4.54605'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 354.129 192.225)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 358.112 195.239)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 351.257 193.699)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 345.208 192.339)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 343.306 200.81)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 344.779 203.683)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 346.342 206.153)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 348.309 208.713)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 350.778 207.149)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 353.247 205.586)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 355.806 203.619)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='6.61437'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 342.246 194.216)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='6.61437'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 359.584 198.112)'
        fill='#F0F0F0'
      />
      <rect
        width='4.54605'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 347.677 190.776)'
        fill='#F0F0F0'
      />
      <path
        d='M328.587 346.062L324.152 345.066L323.699 347.083L321.279 346.539L321.732 344.522L318.103 343.707L317.65 345.723L315.231 345.18L313.872 351.23L316.292 351.774L315.748 354.194L317.764 354.647L317.312 356.664L319.328 357.117L318.875 359.133L320.891 359.587L321.344 357.57L323.36 358.023L323.813 356.006L325.829 356.459L326.372 354.039L328.792 354.583L329.154 352.969L326.735 352.426L327.233 350.207L325.217 349.754L325.806 347.132L328.225 347.676L328.587 346.062Z'
        fill='#E7211C'
      />
      <path d='M330.15 348.532L329.698 350.549L327.681 350.096L328.134 348.079L330.15 348.532Z' fill='#E7211C' />
      <rect
        width='2.47967'
        height='2.89379'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 325.806 347.132)'
        fill='#F6EDDA'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 327.278 350.005)'
        fill='#F6EDDA'
      />
      <g filter='url(#filter27_f_3383_10233)'>
        <rect
          width='3.7195'
          height='1.24019'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 318.103 343.707)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter28_f_3383_10233)'>
        <rect
          width='4.54605'
          height='1.24019'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 324.152 345.065)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter29_f_3383_10233)'>
        <rect
          width='1.65324'
          height='0.414023'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 324.307 355.693)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter30_f_3383_10233)'>
        <rect
          width='2.06639'
          height='2.48039'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 321.887 355.15)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter31_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 319.056 358.327)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter32_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 317.493 355.857)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter33_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 315.839 353.791)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter34_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 326.957 353.323)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter35_f_3383_10233)'>
        <rect
          width='2.47967'
          height='6.20097'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 315.231 345.18)'
          fill='#A60400'
        />
      </g>
      <rect
        width='4.54605'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 324.695 342.646)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 328.678 345.659)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 321.823 344.119)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 315.775 342.76)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 313.872 351.23)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 315.345 354.104)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 316.908 356.573)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 318.875 359.134)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 321.344 357.57)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 323.813 356.006)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 326.372 354.039)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='6.61437'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 312.812 344.637)'
        fill='#F0F0F0'
      />
      <rect
        width='2.47967'
        height='6.61437'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 330.15 348.532)'
        fill='#F0F0F0'
      />
      <rect
        width='4.54605'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 318.244 341.196)'
        fill='#F0F0F0'
      />
      <path
        d='M144.961 261.031L141.137 260.172L140.746 261.91L138.661 261.442L139.051 259.703L135.922 259L135.532 260.739L133.446 260.27L132.275 265.486L134.36 265.955L133.892 268.041L135.63 268.432L135.24 270.171L136.978 270.561L136.587 272.3L138.326 272.691L138.716 270.952L140.454 271.343L140.845 269.604L142.583 269.994L143.051 267.908L145.137 268.377L145.45 266.986L143.364 266.517L143.793 264.604L142.055 264.214L142.563 261.953L144.649 262.422L144.961 261.031Z'
        fill='#E7211C'
      />
      <path d='M146.309 263.16L145.918 264.899L144.18 264.508L144.57 262.77L146.309 263.16Z' fill='#E7211C' />
      <rect
        width='2.13785'
        height='2.49488'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 142.563 261.954)'
        fill='#F6EDDA'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 143.832 264.431)'
        fill='#F6EDDA'
      />
      <g filter='url(#filter36_f_3383_10233)'>
        <rect
          width='3.20677'
          height='1.06923'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 135.922 259)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter37_f_3383_10233)'>
        <rect
          width='3.91939'
          height='1.06923'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 141.137 260.171)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter38_f_3383_10233)'>
        <rect
          width='1.42534'
          height='0.35695'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 141.27 269.334)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter39_f_3383_10233)'>
        <rect
          width='1.78154'
          height='2.13847'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 139.185 268.866)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter40_f_3383_10233)'>
        <rect
          width='1.78154'
          height='0.712823'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 136.744 271.604)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter41_f_3383_10233)'>
        <rect
          width='1.78154'
          height='0.712823'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 135.396 269.475)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter42_f_3383_10233)'>
        <rect
          width='1.78154'
          height='0.712823'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 133.97 267.694)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter43_f_3383_10233)'>
        <rect
          width='1.78154'
          height='0.712823'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 143.555 267.291)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter44_f_3383_10233)'>
        <rect
          width='2.13785'
          height='5.34617'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 133.446 260.27)'
          fill='#A60400'
        />
      </g>
      <rect
        width='3.91939'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 141.605 258.085)'
        fill='#F0F0F0'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 145.039 260.684)'
        fill='#F0F0F0'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 139.129 259.355)'
        fill='#F0F0F0'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 133.915 258.184)'
        fill='#F0F0F0'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 132.275 265.486)'
        fill='#F0F0F0'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 133.544 267.963)'
        fill='#F0F0F0'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 134.892 270.093)'
        fill='#F0F0F0'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 136.587 272.3)'
        fill='#F0F0F0'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 138.716 270.952)'
        fill='#F0F0F0'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 140.845 269.604)'
        fill='#F0F0F0'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 143.051 267.908)'
        fill='#F0F0F0'
      />
      <rect
        width='2.13785'
        height='5.70258'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 131.36 259.802)'
        fill='#F0F0F0'
      />
      <rect
        width='2.13785'
        height='5.70258'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 146.309 263.161)'
        fill='#F0F0F0'
      />
      <rect
        width='3.91939'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 136.043 256.835)'
        fill='#F0F0F0'
      />
      <path
        d='M64.8637 303.131L60.161 306.95L61.896 309.088L59.3309 311.17L57.5959 309.032L53.7482 312.156L55.4832 314.294L52.9181 316.377L58.123 322.792L60.6881 320.709L62.77 323.275L64.9076 321.54L66.6426 323.678L68.7802 321.942L70.5152 324.081L72.6527 322.345L70.9178 320.207L73.0554 318.471L71.3204 316.333L73.458 314.598L71.376 312.032L73.9412 309.949L72.5532 308.238L69.9881 310.321L68.0796 307.969L65.942 309.704L63.6866 306.925L66.2517 304.842L64.8637 303.131Z'
        fill='#E7211C'
      />
      <path d='M68.7363 303.534L70.4712 305.672L68.3336 307.408L66.5987 305.27L68.7363 303.534Z' fill='#E7211C' />
      <rect
        width='3.30411'
        height='3.85505'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 63.6866 306.924)'
        fill='#F6EDDA'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 67.9062 307.755)'
        fill='#F6EDDA'
      />
      <g filter='url(#filter45_f_3383_10233)'>
        <rect
          width='4.95616'
          height='1.65216'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 53.748 312.155)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter46_f_3383_10233)'>
        <rect
          width='6.05753'
          height='1.65216'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 60.1611 306.949)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter47_f_3383_10233)'>
        <rect
          width='2.20274'
          height='0.550721'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 71.4012 315.558)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter48_f_3383_10233)'>
        <rect
          width='2.75342'
          height='3.30432'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 68.8358 317.641)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter49_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 69.821 323.225)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter50_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 65.9483 322.822)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter51_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 62.423 322.848)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter52_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 71.1094 310.829)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter53_f_3383_10233)'>
        <rect
          width='3.30411'
          height='8.26081'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 52.9181 316.377)'
          fill='#A60400'
        />
      </g>
      <rect
        width='6.05753'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 58.0788 304.383)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 64.5166 302.704)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 57.2488 308.604)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 50.8361 313.811)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 58.123 322.792)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 62.3425 323.622)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 66.2151 324.025)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 70.5149 324.081)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 70.9178 320.207)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 71.3204 316.333)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 71.3762 312.032)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='8.81153'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 50.3531 318.459)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='8.81153'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 68.7361 303.534)'
        fill='#F0F0F0'
      />
      <rect
        width='6.05753'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 51.2387 309.937)'
        fill='#F0F0F0'
      />
      <path
        d='M45.3277 166.869L40.625 170.687L42.36 172.826L39.7949 174.908L38.0599 172.77L34.2123 175.894L35.9472 178.032L33.3821 180.115L38.587 186.53L41.1521 184.447L43.2341 187.013L45.3717 185.277L47.1066 187.416L49.2442 185.68L50.9792 187.819L53.1168 186.083L51.3818 183.945L53.5194 182.209L51.7844 180.071L53.922 178.335L51.8401 175.769L54.4052 173.687L53.0172 171.976L50.4521 174.059L48.5436 171.707L46.406 173.442L44.1506 170.662L46.7157 168.58L45.3277 166.869Z'
        fill='#E7211C'
      />
      <path d='M49.2003 167.272L50.9353 169.41L48.7977 171.146L47.0627 169.008L49.2003 167.272Z' fill='#E7211C' />
      <rect
        width='3.30411'
        height='3.85505'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 44.1507 170.662)'
        fill='#F6EDDA'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 48.3702 171.493)'
        fill='#F6EDDA'
      />
      <g filter='url(#filter54_f_3383_10233)'>
        <rect
          width='4.95616'
          height='1.65216'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 34.212 175.893)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter55_f_3383_10233)'>
        <rect
          width='6.05753'
          height='1.65216'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 40.6251 170.687)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter56_f_3383_10233)'>
        <rect
          width='2.20274'
          height='0.550721'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 51.8652 179.296)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter57_f_3383_10233)'>
        <rect
          width='2.75342'
          height='3.30432'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 49.2998 181.378)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter58_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 50.285 186.962)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter59_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 46.4123 186.56)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter60_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 42.8871 186.585)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter61_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 51.5734 174.567)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter62_f_3383_10233)'>
        <rect
          width='3.30411'
          height='8.26081'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 33.3821 180.115)'
          fill='#A60400'
        />
      </g>
      <rect
        width='6.05753'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 38.5428 168.121)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 44.9806 166.441)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 37.7128 172.342)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 31.3001 177.548)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 38.587 186.529)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 42.8065 187.359)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 46.6791 187.763)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 50.9789 187.818)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 51.3818 183.944)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 51.7844 180.071)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 51.8402 175.77)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='8.81153'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 30.8171 182.197)'
        fill='#F0F0F0'
      />
      <rect
        width='3.30411'
        height='8.81153'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 49.2001 167.271)'
        fill='#F0F0F0'
      />
      <rect
        width='6.05753'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 31.7027 173.675)'
        fill='#F0F0F0'
      />
      <defs>
        <filter
          id='filter0_f_3383_10233'
          x='60.7271'
          y='59.3838'
          width='10.371'
          height='8.7128'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.2949' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter1_f_3383_10233'
          x='68.2536'
          y='55.5552'
          width='11.3745'
          height='9.16299'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.2949' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter2_f_3383_10233'
          x='78.4913'
          y='69.9261'
          width='4.21674'
          height='3.38748'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter3_f_3383_10233'
          x='75.4807'
          y='71.0526'
          width='5.84351'
          height='6.12137'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter4_f_3383_10233'
          x='74.9984'
          y='76.6966'
          width='4.94284'
          height='4.11356'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter5_f_3383_10233'
          x='71.3637'
          y='75.3133'
          width='4.94284'
          height='4.11356'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter6_f_3383_10233'
          x='67.9543'
          y='74.4315'
          width='4.94284'
          height='4.11356'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter7_f_3383_10233'
          x='79.424'
          y='65.0619'
          width='4.94284'
          height='4.11356'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter8_f_3383_10233'
          x='58.8424'
          y='63.9209'
          width='11.5677'
          height='14.06'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.2949' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter9_f_3383_10233'
          x='315.177'
          y='48.0469'
          width='15.2078'
          height='11.5482'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.89889' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter10_f_3383_10233'
          x='326.98'
          y='50.6993'
          width='16.7816'
          height='11.9022'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.89889' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter11_f_3383_10233'
          x='329.98'
          y='73.7823'
          width='6.23325'
          height='4.40357'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter12_f_3383_10233'
          x='324.374'
          y='72.7213'
          width='7.90395'
          height='8.51587'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter13_f_3383_10233'
          x='319.556'
          y='78.921'
          width='7.1969'
          height='5.36743'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter14_f_3383_10233'
          x='316.506'
          y='74.1017'
          width='7.1969'
          height='5.36743'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter15_f_3383_10233'
          x='313.278'
          y='70.069'
          width='7.1969'
          height='5.36743'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter16_f_3383_10233'
          x='334.975'
          y='69.1564'
          width='7.1969'
          height='5.36743'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter17_f_3383_10233'
          x='307.451'
          y='50.9215'
          width='14.9683'
          height='20.4637'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.89889' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter18_f_3383_10233'
          x='345.319'
          y='191.341'
          width='7.7929'
          height='5.91756'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter19_f_3383_10233'
          x='351.368'
          y='192.699'
          width='8.59935'
          height='6.09871'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter20_f_3383_10233'
          x='352.904'
          y='204.528'
          width='3.19435'
          height='2.25722'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter21_f_3383_10233'
          x='350.032'
          y='203.984'
          width='4.05019'
          height='4.36366'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter22_f_3383_10233'
          x='347.563'
          y='207.161'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter23_f_3383_10233'
          x='346'
          y='204.691'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter24_f_3383_10233'
          x='344.346'
          y='202.625'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter25_f_3383_10233'
          x='355.464'
          y='202.158'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter26_f_3383_10233'
          x='341.36'
          y='192.814'
          width='7.67016'
          height='10.4859'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter27_f_3383_10233'
          x='315.886'
          y='341.761'
          width='7.79291'
          height='5.91756'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter28_f_3383_10233'
          x='321.934'
          y='343.119'
          width='8.59935'
          height='6.09871'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter29_f_3383_10233'
          x='323.471'
          y='354.948'
          width='3.19435'
          height='2.25722'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter30_f_3383_10233'
          x='320.599'
          y='354.405'
          width='4.05019'
          height='4.36366'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter31_f_3383_10233'
          x='318.13'
          y='357.581'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter32_f_3383_10233'
          x='316.566'
          y='355.112'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter33_f_3383_10233'
          x='314.912'
          y='353.045'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter34_f_3383_10233'
          x='326.03'
          y='352.578'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter35_f_3383_10233'
          x='311.926'
          y='343.234'
          width='7.67015'
          height='10.4859'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter36_f_3383_10233'
          x='134.01'
          y='257.322'
          width='6.71868'
          height='5.10173'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.83891' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter37_f_3383_10233'
          x='139.225'
          y='258.494'
          width='7.41396'
          height='5.25798'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.83891' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter38_f_3383_10233'
          x='140.55'
          y='268.692'
          width='2.75401'
          height='1.94578'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter39_f_3383_10233'
          x='138.074'
          y='268.223'
          width='3.49186'
          height='3.76219'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter40_f_3383_10233'
          x='135.945'
          y='270.962'
          width='3.17952'
          height='2.37108'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter41_f_3383_10233'
          x='134.597'
          y='268.833'
          width='3.17952'
          height='2.37108'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter42_f_3383_10233'
          x='133.171'
          y='267.051'
          width='3.17952'
          height='2.37108'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter43_f_3383_10233'
          x='142.757'
          y='266.648'
          width='3.17952'
          height='2.37108'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter44_f_3383_10233'
          x='130.597'
          y='258.592'
          width='6.61284'
          height='9.0407'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.83891' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter45_f_3383_10233'
          x='51.1552'
          y='306.438'
          width='10.0743'
          height='9.59288'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter46_f_3383_10233'
          x='57.5682'
          y='300.538'
          width='10.9293'
          height='10.2872'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter47_f_3383_10233'
          x='70.4082'
          y='313.177'
          width='4.04306'
          height='3.80191'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter48_f_3383_10233'
          x='67.8428'
          y='314.912'
          width='6.20554'
          height='6.28727'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter49_f_3383_10233'
          x='68.828'
          y='320.496'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter50_f_3383_10233'
          x='64.9553'
          y='320.094'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter51_f_3383_10233'
          x='61.43'
          y='320.119'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter52_f_3383_10233'
          x='70.1164'
          y='308.101'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter53_f_3383_10233'
          x='50.3252'
          y='311.702'
          width='12.9556'
          height='13.6832'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter54_f_3383_10233'
          x='31.6192'
          y='170.176'
          width='10.0743'
          height='9.59288'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter55_f_3383_10233'
          x='38.0322'
          y='164.276'
          width='10.9293'
          height='10.2872'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter56_f_3383_10233'
          x='50.8722'
          y='176.915'
          width='4.04306'
          height='3.80191'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter57_f_3383_10233'
          x='48.3068'
          y='178.65'
          width='6.20554'
          height='6.28727'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter58_f_3383_10233'
          x='49.292'
          y='184.234'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter59_f_3383_10233'
          x='45.4193'
          y='183.832'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter60_f_3383_10233'
          x='41.8941'
          y='183.857'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter61_f_3383_10233'
          x='50.5804'
          y='171.839'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter62_f_3383_10233'
          x='30.7893'
          y='175.439'
          width='12.9556'
          height='13.6832'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_10233' />
        </filter>
      </defs>
    </svg>
  )
}

export function OnboardImage4() {
  return (
    <>
      <div className='show-on-dark-theme'>
        <OnboardImage4Dark />
      </div>
      <div className='show-on-light-theme'>
        <OnboardImage4Light />
      </div>
    </>
  )
}
